import { BotaoAcao, BotaoContorno, type BotaoAcaoProps } from "./BotaoAcao";

export type BotaoTopoProps = Omit<BotaoAcaoProps, "estilo" | "variante">;

export function BotaoTopoSecundario(props: BotaoTopoProps) {
  return <BotaoContorno {...props} estilo="topo" />;
}

export function BotaoTopoPrimario(props: BotaoTopoProps) {
  return <BotaoAcao {...props} estilo="topo" variante="primario" />;
}
